import { SideModals } from 'commons/utils/constants';

export type SidemodalState = {
  [SideModals.ADDCREDIT]: boolean;
  [SideModals.BILLING_ADJUSTS]: boolean;
  [SideModals.CANCELLATION_ORDERS]: boolean;
  [SideModals.CHARGE_HISTORY]: boolean;
  [SideModals.FILTERS]: boolean;
  [SideModals.FREIGHT_CALCULATOR]: boolean;
  [SideModals.FREIGHT_CALCULATOR_TABLE]: boolean;
  [SideModals.GENERATE_FILES]: boolean;
  [SideModals.GENERATE_ROMANEIO]: boolean;
  [SideModals.OWN_CONTRACT_CORREIOS]: boolean;
  [SideModals.DETAILS_SHIPMENT_PRINT]: boolean;
  [SideModals.DETAILS_SHIPMENT_QUOTATION]: boolean;
  [SideModals.DETAILS_SHIPMENT_SIMULATE]: boolean;
  [SideModals.DETAILS_SHIPMENT_CANCELLATION_ORDER]: boolean;
  [SideModals.WELCOME_GO_PLUS]: boolean;
  [SideModals.WELCOME_FIRST_SHIPMENT]: boolean;
  [SideModals.GENERATE_FILES_FROM_ORDERS]: boolean;
  [SideModals.MISSING_FISCAL_DOCUMENT_INFORMATION]: boolean;
  [SideModals.IFOOD_TRACKING]: boolean;
};

const initialState: SidemodalState = {
  [SideModals.ADDCREDIT]: false,
  [SideModals.BILLING_ADJUSTS]: false,
  [SideModals.CANCELLATION_ORDERS]: false,
  [SideModals.CHARGE_HISTORY]: false,
  [SideModals.FILTERS]: false,
  [SideModals.FREIGHT_CALCULATOR]: false,
  [SideModals.FREIGHT_CALCULATOR_TABLE]: false,
  [SideModals.GENERATE_FILES]: false,
  [SideModals.GENERATE_ROMANEIO]: false,
  [SideModals.OWN_CONTRACT_CORREIOS]: false,
  [SideModals.DETAILS_SHIPMENT_PRINT]: false,
  [SideModals.DETAILS_SHIPMENT_QUOTATION]: false,
  [SideModals.DETAILS_SHIPMENT_SIMULATE]: false,
  [SideModals.DETAILS_SHIPMENT_CANCELLATION_ORDER]: false,
  [SideModals.WELCOME_GO_PLUS]: false,
  [SideModals.WELCOME_FIRST_SHIPMENT]: false,
  [SideModals.GENERATE_FILES_FROM_ORDERS]: false,
  [SideModals.MISSING_FISCAL_DOCUMENT_INFORMATION]: false,
  [SideModals.IFOOD_TRACKING]: false
};

export type Action =
  | {
      type: 'OPEN_MODAL';
      payload: SideModals;
    }
  | { type: 'CLOSE_MODAL'; payload: SideModals };

const sidemodalsReducer = (
  state: SidemodalState,
  action: Action
): SidemodalState => {
  switch (action.type) {
    case 'OPEN_MODAL':
      return { ...state, [action.payload]: true };

    case 'CLOSE_MODAL':
      return { ...state, [action.payload]: false };

    default:
      return state;
  }
};

export { initialState, sidemodalsReducer };
